module.exports = __webpack_public_path__ + "img/IMG_2629_P_L_Black_MockedUp.f90cb6d8.jpg";